import { EntityQuery } from 'breeze-client';

const baseQuery = EntityQuery.from('ReportInfos').orderBy('name');

export const reportInfoQueries = {
  selectAll: baseQuery,
  selectHasAny: baseQuery.select('name').take(1)
};
